import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import styled from "styled-components";
import { HiDotsHorizontal } from "react-icons/hi";
import { Flex } from "rebass/styled-components";
import { openWebShare, trackClipSocialShare } from "./utils";

const StyledShare = styled(HiDotsHorizontal)`
  position: relative;
  color: #abbcc8;
  padding: 8px;
  background: #1a2329;
  border-radius: 50%;
  margin-right: 5px;
`;

export default function MobileShare({ file, clip, ...props }) {
  return (
    <>
      <ShareButton
        justifyContent="center"
        alignItems="center"
        flex={true}
        target="_blank"
        onClick={async () => {
          try {
            openWebShare({ file, clip });
            trackClipSocialShare({
              platform: "App Share",
              clip,
            });
          } catch (e) {}
        }}
        {...props}
      >
        <Flex alignItems="center" justifyContent="center">
          <StyledShare size={18}></StyledShare>
          <Flex alignItems="flex-start" flexDirection="column"></Flex>
          {props.children}
        </Flex>
      </ShareButton>
    </>
  );
}
